import { AxiosResponse } from 'axios'
import createAPIClient from '../services/apiClient'
import { ProjectMembershipQuery, ProjectMembership } from '../types'
import { ProjectMembershipRole } from '../enums'

const api = createAPIClient('/v2')

export interface CreateMembership {
  projectId: number
  memberId: number
  role: string
}

export interface UpdateMembership {
  projectId: number
  memberId: number
  role: ProjectMembershipRole
  showInAppNotifications?: boolean
}

export async function createProjectMembership(
  membership: CreateMembership
): Promise<AxiosResponse> {
  const response = await api.post('/project-memberships', membership)

  return response.data
}

export async function deleteProjectMembership(id: string): Promise<AxiosResponse> {
  const response = await api.delete(`/project-memberships/${id}`)

  return response.data
}

export async function updateProjectMembership(
  id: string,
  membership: UpdateMembership
): Promise<ProjectMembership> {
  const response = await api.put(`/project-memberships/${id}`, membership)

  return response.data
}

export async function getProjectMembership(
  user: ProjectMembershipQuery
): Promise<ProjectMembership | undefined> {
  const response = await api.get(`/project-memberships`, {
    params: {
      memberId: user.memberId,
      projectId: user.projectId
    }
  })

  if (!response.data.length) {
    return undefined
  }

  return response.data[0]
}

export default {
  getProjectMembership,
  createProjectMembership,
  updateProjectMembership,
  deleteProjectMembership
}
